<script>
export default {
	emits: ['do-order'],
	methods: {
		getDayMonth(dateString) {
			return new Date(dateString).toLocaleDateString('nl-NL', {
				weekday: 'short',
				day: 'numeric',
				month: 'short',
			});
		},
		getTime(dateString) {
			return new Date(dateString).toLocaleTimeString('nl-NL', {
				hour: 'numeric',
				minute: 'numeric',
			});
		},
		buttonStatusClass(status) {
			//NotSet = 0,
			//Available = 1,
			//SoldOut = 2,
			//Cancelled = 3,
			//LastTickets = 4
			switch (status) {
				case '0':
					return '';
					break;
				case '1':
					return '';
					break;
				case '2':
					return 'is-theatre';
					break;
				case '3':
					return 'disabled';
					break;
				case '4':
					return 'is-theatre';
					break;
				default:
					return '';
			}
		},
		doOrder(availability, orderButton, eventStartDate, eventEndDate) {
			this.$emit('do-order', availability, orderButton, eventStartDate, eventEndDate);
		},
	},
	props: ['activityid', 'event'],
};
</script>
<template>
	<a v-if="event.orderButton.isClickable && activityid !== event.id"
	   @click.prevent="doOrder(event.availability, event.orderButton, event.startDate, event.endDate)"
	   :href="event.orderButton.url"
	   class="order order-with-date is-flex is-flex-direction-column is-justify-content-space-between"
	   :title="
			event.orderButton.text +
			': ' +
			getDayMonth(event.startDate) +
			' ' +
			getTime(event.startDate)
		">
		<time
			:datetime="event.startDate"
			class="is-flex is-justify-content-center order-date">
			<span class="order-date-date">{{ getDayMonth(event.startDate) }}</span>
			<span class="order-date-divider">|</span>
			<span class="order-date-time">
				{{ getTime(event.startDate) }}
				<template v-if="event.endDate !== null">
					- {{ getTime(event.endDate) }}
				</template>
			</span>
		</time>
		<span v-if="event.orderButton.textBelowTime" class="order-extra-text">
			{{ event.orderButton.textBelowTime }}
		</span>
		<span
			:class="[
				'button',
				'is-orderbutton',
				'is-solid',
				buttonStatusClass(event.orderButton.status)
			]"
			>{{ event.orderButton.text }}</span
		>
	</a>
	<span v-else-if="activityid !== event.id" class="order order-with-date is-flex is-flex-direction-column is-justify-content-space-between">
		<time :datetime="event.startDate"
			  class="is-flex is-justify-content-center order-date">
			<span class="order-date-date">{{ getDayMonth(event.startDate) }}</span>
			<span class="order-date-divider">|</span>
			<span class="order-date-time">
				{{ getTime(event.startDate) }}
				<template v-if="event.endDate !== null">
					- {{ getTime(event.endDate) }}
				</template>
			</span>
		</time>
		<span v-if="event.orderButton.textBelowTime" class="order-extra-text">
			{{ event.orderButton.textBelowTime }}
		</span>
		<span :class="[
				'button',
				'is-orderbutton',
				'is-solid',
				buttonStatusClass(event.orderButton.status),
			]">{{ event.orderButton.text }}</span>
	</span>
</template>
